module.exports = __webpack_public_path__ + "static/media/md-boat.043fbf8d.svg";